export default __webpack_public_path__ + "static/media/iot_img.4b2e9e58.jpg";